import Ventana from "../../../isp._comun/iu/_principal/reductores/Ventana";
import { DialogType, ModosOp } from "../../../isp._comun/iu/_principal/constantesIuPrin";
import getEstadoInicial from "../EstadoDialogoItem";

export default class VentanaItem extends Ventana {
    constructor(estadoComp) {
        super();
        this.id= DialogType.ITEM+estadoComp.domain.screen.idItem;
        this.estadoComp = estadoComp;
    }

    static nuevaVentanaEnModoCrear() {
        return new VentanaItem(getEstadoInicial());
    }

    static nuevaVentanaEnModoOk(idItem) {
        const estadoComp = getEstadoInicial();
        estadoComp.flag.modoOperacion = ModosOp.OK;
        estadoComp.domain.screen.idItem = idItem;
        estadoComp.flag.modal = true;
        estadoComp.flag.cargandoEntidad = true;
        return new VentanaItem(estadoComp);
    }

    puedeHacersePasarPor(ventanaAAbrir) {
        if (!(ventanaAAbrir instanceof VentanaItem)) {
            return false;
        }
        if(this.id === ventanaAAbrir.id){
            return true;
        }
        return false;
    }

    clonar() {
        const nuevaVentana = new VentanaItem(this.estadoComp);
        nuevaVentana.posicionZ = this.posicionZ;
        return nuevaVentana;
    }
}
